import { IS_DEV as IS_DEV_FROM_CONFIG } from '~/shared/config';

/** Canonical marketing site (terms, privacy, contact). Not environment-specific. */
export const MARKETING_SITE_BASE_URL = 'https://www.joinsynapsis.com';

export const FOOTER_TERMS_OF_SERVICE_URL = `${MARKETING_SITE_BASE_URL}/terms/`;

export const FOOTER_PRIVACY_POLICY_URL = `${MARKETING_SITE_BASE_URL}/privacy/`;

export const FOOTER_CONTACT_URL = `${MARKETING_SITE_BASE_URL}/contact/`;

export enum LocalStorageKeys {
  StoredId = 'storedId',
}

export const IS_DEV = IS_DEV_FROM_CONFIG;

export const PLATFORM_FEE_PERCENT = 15;

export const PLATFORM_FEE_RATE = PLATFORM_FEE_PERCENT / 100;

export const CENTS_PER_DOLLAR = 100;

export const DEFAULT_MESSAGE_LIMIT = 50;
